module.exports = __webpack_public_path__ + "static/img/7.5877b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/pengu/7.png
// module id = hL0C
// module chunks = 35